import { useMatches } from '@tanstack/react-router';
import type { FileRouteTypes } from '@/routeTree.gen.ts';
import type { OrgScope } from './orgScope.ts';

export interface ResolvedOrgScope {
  scope: OrgScope;
  /** For a `record` page: the list to land on when another organisation is chosen. */
  list: FileRouteTypes['to'] | undefined;
}

/* The deepest matched route that declares a scope wins, so a layout route can set one for its children. */
export function useOrgScope(): ResolvedOrgScope {
  const scope = useMatches({
    select: (matches) =>
      [...matches].reverse().find((match) => match.staticData.orgScope !== undefined)
        ?.staticData.orgScope,
  });
  const list = useMatches({
    select: (matches) =>
      [...matches].reverse().find((match) => match.staticData.orgScope !== undefined)
        ?.staticData.orgScopeList,
  });

  return { scope: scope ?? 'none', list };
}
